import { createRouter } from "@tanstack/react-router";
import { accountRoute } from "./views/dashboard/Account";
import { customerLandingRoute } from "./views/dashboard/CustomerLanding";
import { customerLayoutRoute } from "./views/dashboard/Dashboard";
import { analyticsRoute } from "./views/dashboard/services/Analytics";
import { loginRoute } from "./views/Login";
import { organisationAdminRoute } from "./views/dashboard/admin/OrganisationAdmin";
import { emergencyMessageSettingsRoute } from "./views/dashboard/services/EmergencyMessageSettings";
import { emailVerificationSettingsRoute } from "./views/dashboard/services/EmailVerificationSettings";
import { rootRoute } from "./__root";
import { brandingRoute } from "./views/dashboard/services/Branding";
import { acceptInviteRoute } from "./views/AcceptInvite";
import { registerRoute } from "./views/Register";
import { verifyAccountRoute } from "./views/VerifyAccount";
import { forgotPasswordRoute } from "./views/ForgotPassword";
import { resetPasswordRoute } from "./views/ResetPassword";
import { optInRoute } from "./views/dashboard/admin/OptIn";
import { broadcastRoute } from "./views/dashboard/services/Broadcast";
import { adminsRoute } from "./views/dashboard/services/Admins";
import { resourcePageSettingsRoute } from "./views/dashboard/services/ResourcePages/ResourcePageSettings";
import { userSegmentsRoute } from "./views/dashboard/services/UserSegments";
import { surveysRoute } from "./views/dashboard/services/Surveys";
import { surveyBuilderRoute } from "./views/dashboard/services/Surveys/SurveyBuilder";
import { surveyResultsRoute } from "./views/dashboard/services/Surveys/SurveyResults";
import { apiKeysRoute } from "./views/dashboard/services/APIKeys";
import { surveyDashboardRoute } from "./views/dashboard/services/Surveys/SurveyDashboard/SurveyDashboard";
import { resourcePagesRoute } from "./views/dashboard/services/ResourcePages/ResourcePages";
import { layoutRoute } from "./views/dashboard/services/Layouts/LayoutEditor";
import { onboardingRoute } from "./views/dashboard/services/Onboarding";
import { onboardingFlowchartRoute } from "./views/dashboard/services/Onboarding/Flowchart";
import { emergencyCallsRoute } from "./views/dashboard/services/EmergencyCalls";
import { playbackRoute } from "./views/dashboard/services/EmergencyCalls/Playback";
import { layoutsRoute } from "./views/dashboard/services/Layouts";
import { hubLayoutRoute, hubIndexRoute } from "./views/portal";
import { endUserCallViewerRoute } from "./views/callViewer/EndUserCallViewer";
import { dummyParticipantsRoute } from "./views/dashboard/services/EmergencyCalls/DummyParticipants";
import { endUsersRoute, endUserDetailRoute } from "./views/dashboard/services/EndUsers";

export const routeTree = rootRoute.addChildren([
  loginRoute,
  registerRoute,
  verifyAccountRoute,
  acceptInviteRoute,
  forgotPasswordRoute,
  resetPasswordRoute,

  endUserCallViewerRoute,

  hubLayoutRoute.addChildren([hubIndexRoute, accountRoute, optInRoute]),

  customerLayoutRoute.addChildren([
    customerLandingRoute,

    emergencyMessageSettingsRoute,
    emailVerificationSettingsRoute,
    brandingRoute,
    analyticsRoute,
    broadcastRoute,
    resourcePagesRoute,
    resourcePageSettingsRoute,
    apiKeysRoute,
    adminsRoute,
    userSegmentsRoute,
    surveysRoute,
    surveyBuilderRoute,
    surveyResultsRoute,
    surveyDashboardRoute,
    layoutsRoute,
    layoutRoute,
    onboardingRoute,
    onboardingFlowchartRoute,
    emergencyCallsRoute,
    playbackRoute,
    dummyParticipantsRoute,
    organisationAdminRoute,
    endUsersRoute,
    endUserDetailRoute,
  ]),
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
